export interface ErrorMessage {
  summary: string;
  detail: string;
}

export const HTTP_ERROR_MESSAGES: Record<number, ErrorMessage> = {
  0: {
    summary: 'Network Error',
    detail: 'Unable to connect to the server. Please check your internet connection.'
  },
  400: {
    summary: 'Bad Request',
    detail: 'Invalid request. Please check your input and try again.'
  },
  401: {
    summary: 'Authentication Error',
    detail: 'Session expired. Please login again.'
  },
  403: {
    summary: 'Access Forbidden',
    detail: 'You do not have permission to access this resource.'
  },
  404: {
    summary: 'Not Found',
    detail: 'The requested resource was not found.'
  },
  500: {
    summary: 'Server Error',
    detail: 'Internal server error. Please try again later.'
  },
  502: {
    summary: 'Service Unavailable',
    detail: 'Service is temporarily unavailable. Please try again later.'
  },
  503: {
    summary: 'Service Unavailable',
    detail: 'Service is currently under maintenance. Please try again later.'
  }
};

export const DEFAULT_ERROR_MESSAGE: ErrorMessage = {
  summary: 'Error',
  detail: 'An unexpected error occurred. Please try again.'
};

export const AUTH_ERROR_MESSAGE: ErrorMessage = {
  summary: 'Authentication Error',
  detail: 'Session expired. Please login again.'
};
